<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="资质信誉"
      third-bread="资质信誉查看"
      first-url="/user/sign"
      second-url="/user/quality"
      title-name="资质信誉查看"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="图片">
          <el-image class="item-image" :src="'http://'+LookData.photoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="商品介绍">
          <el-input  type="textarea"
                     :rows="4"
                     :placeholder="LookData.description"  disabled></el-input>
        </el-form-item>
        <el-form-item label="所属类型">
          <el-input :placeholder="LookData.type" disabled></el-input>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "QualityLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/certification/getById/'+id).then(res=>{
          this.LookData=res.data.data

        })
      }
    }
  }
</script>

<style scoped>

</style>